import { Prompt, PicLink, EventBanner,ScrollReset} from './obj.js'

import poster from './img/advent/Adventposter.webp'
import poster2 from './img/advent/advent_of_MAPS_2025.webp'



export default function Advent(){
    return (<>
        <main className = "eventpage">
            <ScrollReset/>
            <EventBanner>Advent of<br/>MAPS</EventBanner>
            <section className= "twocol">
                <Prompt text = "Workshops >>">
                    This competition is held digitally over the course of a month. One problem is released each day, and programmers must solve it as fast as possible to earn the most points. With only one test-case per problem, participants are encouraged to use unconventional solutions to solve problems.
                </Prompt>
                <div className = 'twobytwo'>
                    <br/>
                    <PicLink src = {poster}></PicLink>
                    <PicLink src = {poster2}></PicLink>
                    <br/>
                </div>
            </section>
        </main>
    </>)
}